module.exports = __webpack_public_path__ + "img/John_Leguizamo.832e3089.jpg";